<template>
    <div class="listmain ">
         <h1 class="firTitle">音频播放</h1>
              <p>开发者对终端设备进行音频播放控制，音频播放指令将从技能发送给OrionOS，OrionOS解析后对终端设备进行音频播放控制。
              </p>
               <p>协议提供音频播放的能力，音频播放供包含两种类型：stream（云端URL） 和 command（控制客户端进行音频播放，只在特殊版本的智能硬件生效），音频播放推荐使用云端URL的方式进行播放。如果返回的歌曲存在下一首直接在协议层面进行 hasNext 字段的设置，终端设备SDK根据该字段描述进行控制。
              </p>


              <h5 class="thirdTitle">请求头信息：</h5>
              <p>POST : /intent/invoke HTTP/1.1
                <br>Content-Type : application/x-www-form-urlencoded;charset=UTF-8
                <br>Host : ovs.ainirobot.com
                <br>Content-Length:
                <br>Accept : application/json
                <br>Accept-Charset : utf-8

              </p>
               <h5 class="thirdTitle">请求内容格式规范及参数说明</h5>
               <p>Response Body Syntax
              </p>
              <h5 class="codeTitle">音频播放</h5>
               <highlight-code lang="javascript">
                   {
                "type": "AudioPlayer.Play",//Type:String
                       "audioItem": {//Type:JSONObject
                                "stream": { //Type:JSONObject,音频流
                                    "url": "",//Type:String 播放的URL
                                    "token": "", //Type:String 播放音频的唯一标示
                                    "offsetInMilliSeconds": 0,//Type:int
                                },
                        "command": { //Type:JSONObject,前端指令，兼容百度音乐SDK，虾米音乐SDK
                                    "result": {//Type:JSONObject
                                        "fail": [//Type:JSONArray
                                            "没有找到要点播的音乐，换一个试试吧"//Type:String
                                        ],
                                        "success": [//Type:JSONArray
                                            "好的，刘德华,忘情水"//Type:String
                                        ]
                                    },
                                    "function": "playbysongid",//Type:String
                                    "params": [//Type:JSONArray
                                        "2068460"//Type:String
                                    ],
                                    "class": "music"//Type:String
                                }
                            },
                            "hasNext":true/false,//Type:Boolean,是否拥有下一首歌曲，如果有下一首歌曲，客户端在播放结束的时候会进行虚拟意图autoNext的请求。//Type:JSONObject
                }
              </highlight-code>


    </div>
</template>

<script>
export default {
  name: "Ptjj"
};
</script>

<style  rel="stylesheet/scss" lang="scss" scoped>
h1,
h2,
h3,
h4,
h5 {
  padding: 0;
  margin: 0px;
  font-weight: normal;
}

ul,
li {
  list-style: none;
}

.listmain {
  font-size: 14px;
  line-height: 26px;
  .firTitle {
    font-size: 20px;
    color: #1e4d79;
    margin-bottom: 30px;
  }
  .sedTitle {
    font-size: 16px;
    font-weight: bold;
    padding-bottom: 10px;
    border-bottom: 1px solid #f3f3f3;
    margin-bottom: 15px;
    margin-top: 50px;
    &.fir {
      margin-top: 0px;
    }
  }
  .thirdTitle {
    margin-top: 50px;
    font-weight: bold;
    line-height: 26px;
  }
  .codeTitle {
    font-weight: bold;
    line-height: 26px;
  }
  pre {
    margin-top: 20px;
  }
  img {
    margin: 30px 0;
  }
  table,
  table tr th,
  table tr td {
    border: 1px solid #000;
    text-align: center;
  }
  table {
    line-height: 30px;
    width: 100%;
    border-collapse: collapse;
  }
}

.el-submenu .el-menu-item {
  min-width: 190px;
  background: #f5f5f5;
}

.el-submenu {
  min-width: 190px;
  background: #f5f5f5;
}

img {
  margin-top: 30px;
  margin-bottom: 30px;
}
</style>




// WEBPACK FOOTER //
// src/components/tutor/zdyjn_ypbf.vue